import { render } from "./dispatch-email.vue?vue&type=template&id=5622d252&scoped=true"
import script from "./dispatch-email.vue?vue&type=script&lang=js"
export * from "./dispatch-email.vue?vue&type=script&lang=js"

import "./dispatch-email.vue?vue&type=style&index=0&id=5622d252&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5622d252"]])

export default __exports__